<div>
  <h1>{{ greeting }}, {{ firstName() }}!</h1>
</div>
<div>
  <h1 class="app">Dashboard Coming Soon!</h1>
</div>